module.exports = __webpack_public_path__ + "img/step-left-image.5e2df5ec.png";